import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import IconButton from "@mui/material/IconButton";

import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import NotificationsOffOutlinedIcon from '@mui/icons-material/NotificationsOffOutlined';

import api from "../../service/api";
import { setError } from "../../reducers/appSlice";

const BotonSeguir = ({ tramiteId }) => {
    const dispatch = useDispatch();
    const [siguiendo, setSiguiendo] = useState(null);

    const verificarSuscripcion = () => {
        api.estadoSuscripcion({ tramiteId: tramiteId })
            .then((res) => { setSiguiendo(res.data.suscripto) })
            .catch((e) => dispatch(setError("Error al verificar suscripción")));
    };

    const handleSuscribir = () => {
        api.suscribir({ tramiteId: tramiteId })
            .then((res) => setSiguiendo(true))
            .catch((e) => dispatch(setError("Error al seguir el expediente")));
    };

    const handleDesuscribir = () => {
        api.desuscribir({ tramiteId: tramiteId })
            .then((res) => setSiguiendo(false))
            .catch((e) => dispatch(setError("Error al dejar de seguir el expediente")));
    };

    useEffect(() => {
        verificarSuscripcion();
    }, [tramiteId])

    return (
        <IconButton
            title={siguiendo ? "Dejar de seguir" : "Seguir"}
            onClick={siguiendo ? handleDesuscribir : handleSuscribir}
            disabled={siguiendo === null}
        >
            {siguiendo ? <NotificationsOutlinedIcon /> : <NotificationsOffOutlinedIcon />}
        </IconButton>
    );
}

export default BotonSeguir;